import React, { useCallback, useState } from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import TourDealFilterContent from './TourDealFilterContent'

interface RangeFilter {
  min: string | undefined
  max: string | undefined
}

export type TourSearchPageFilterSubmit = {
  operators: Array<string>
  categories: Array<string>
  productTypes: Array<string>
  price: { start: number, end: number }
  duration: { start: number, end: number }
  numberOfPlacesVisited?: RangeFilter
  destinations: Array<string>
  groupTypes: Array<string>
  offerTags: Array<string>
  luxPlusFeatures: Array<string>
  agentHubFeatures: Array<string>
  sortBy?: string
  tourStyles?: Array<string>
  campaigns?: Array<string>
}

interface Props {
  open: boolean
  onClose: () => void
  searchFacets: App.Tours.TourDealFacets
  initialFacets: App.Tours.TourDealFacets
  filtersApplied: App.Tours.TourDealFiltersApplied
  sortOrderApplied: string
  onFilterSubmit: (filters: App.Tours.TourDealFiltersApplied, sortParams?: string) => void
}

function TourDealPageFilters({
  open,
  onClose,
  searchFacets,
  initialFacets,
  filtersApplied,
  sortOrderApplied,
  onFilterSubmit,
}: Props) {
  const [filters, setFilters] = useState<App.Tours.TourDealFiltersApplied>({ ...filtersApplied })
  const [sortParams, setSortParams] = useState<string>(sortOrderApplied)

  const onFilterChange = useCallback((values: App.Tours.TourDealFiltersApplied) => {
    setFilters({ ...values })
  }, [setFilters])

  const onSortChange = useCallback((value: string) => {
    setSortParams(value)
  }, [setSortParams])

  const onFormChange = useCallback(() => {
    onFilterSubmit(filters, sortParams)
  }, [filters, sortParams, onFilterSubmit])

  const onResetForm = useCallback(() => {
    onFilterSubmit({})
  }, [onFilterSubmit])

  const onCloseForm = useCallback(() => {
    setFilters(filtersApplied)
    setSortParams(sortOrderApplied)
    onClose()
  }, [filtersApplied, sortOrderApplied, onClose])

  return open && <ModalBase mode="drawer" isOpen={!!open} onClose={onClose}>
    <ModalHeader title="Sort & Filter" onCloseButtonClick={onCloseForm} />
    <ModalBody>
      <ModalContent>
        <TourDealFilterContent
          modalView
          searchFacets={searchFacets}
          initialFacets={initialFacets}
          filtersApplied={filters}
          sortOrderApplied={sortParams}
          onFilterChange={onFilterChange}
          onSortChange={onSortChange}
        />
      </ModalContent>
    </ModalBody>
    <ModalFooter
      primaryActionProps={{
        children: 'View offers',
        'data-testid': 'view-offers-filter-button',
        onClick: onFormChange,
      }}
      secondaryActionProps={{
        children: 'Reset all',
        onClick: onResetForm,
      }}
    />
  </ModalBase>
}

export default TourDealPageFilters
